import React from "react";
import { Button, Modal } from "react-bootstrap";
import { AddExistingItemForm } from "./form";

export function ModalAddExistingItem({show, setShow, name}){

  return (
    <Modal show={show} onHide={()=>setShow(false)} size='xl' >
      <Modal.Title>Add Existing Source Entries: {`(${name})`}</Modal.Title>
      <Modal.Body>
        <AddExistingItemForm name={name} show={show} />
      </Modal.Body>
      <Modal.Footer>
        {/* <Button>Confirm</Button> */}
        <Button onClick={()=>setShow(false)}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}